import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthenticationStore, { AuthenticationViews } from "./Store";
import { useConfiguration } from './Configuration';
import SetPassword from "./SetPassword";

const SetPasswordContainer: React.FC = () => {
  const { state, dispatch, finishJoin, isValidPassword } = useAuthenticationStore()
  const { serverError, isLoading, emailOrPhone, rememberMe } = state
  const { configuration } = useConfiguration()
  const { productName } = configuration
  const navigate = useNavigate();

  const setEmailOrPhone = (newEmailOrPhone: string) => {
    dispatch({ type: 'SET_EMAIL_OR_PHONE', payload: newEmailOrPhone })
  }

  const setRememberMe = (newRememberMe: boolean) => {
    dispatch({ type: 'SET_REMEMBER_ME', payload: newRememberMe })
  }

  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.join)
    }
  }, [emailOrPhone, navigate])

  return (
    <SetPassword
      serverError={serverError}
      isLoading={isLoading}
      emailOrPhone={emailOrPhone}
      rememberMe={rememberMe}
      productName={productName}
      finishJoin={finishJoin}
      isValidPassword={isValidPassword}
      setEmailOrPhone={setEmailOrPhone}
      setRememberMe={setRememberMe}
    />
  )
}

export default SetPasswordContainer;